import Icon from '@ant-design/icons'
import styled from 'styled-components'

export const DashboardContainer = styled.div``

export const DashboardPatientAdmissionContainer = styled.div`
  padding: 16px 16px 0 16px;
  display: flex;
  flex-direction: column;
`

export const DashboardSecondContainer = styled.div`
  flex: 1 1 0;
  max-width: 30%;
  display: flex;
  flex-direction: column;
`
export const DashboardAlertContainer = styled.div`
  height: calc(100%);
  overflow: hidden;
`

export const DashboardAlertCollaspeContainer = styled.div`
  height: 100%;
  .normal & {
    height: calc(100% - 25px);
  }
`

export const DashboardStatsContainer = styled.div`
  border-radius: 10px;
  flex: 1 1 0;
  display: flex;
  gap: 50px;
  justify-content: space-between;
  align-items: center;

   @media (max-width: 1200px) {
    flex-direction: column;
    margin-top: 130px;
    margin-bottom: 20px;
    gap:15px;
  }
`

export const TableTitleDiv = styled.div`
  padding: 4px 10px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  margin: 5px 0px;
`

export const TableTitle = styled.h2`
  margin: 0px;
  font-size: 1em;
`

export const TableTitleIcon = styled(Icon)`
  font-size: 20px;
`

export const BreadcrumbContainer = styled.div`
  display: flex;
  gap: 20px;
`
